// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3uAEb","head":"Table_head__Lyk6Q","col":"Table_col__3T8s1"};